<template>
  <v-row class="filters--list mb-4">
    <v-col class="filters--list" cols="12" sm="6" md="3" lg="2">
      <v-autocomplete
        @keyup="setCitySearch"
        @change="applyCityFilter"
        @click:clear="clearCityFilter"
        :label="$t('defaultServiceValues.label.city')"
        :no-data-text="$t('appointment.filters.noData')"
        :loading="cityLoading"
        :items="cities"
        item-text="name"
        item-value="id"
        return-object
        hide-no-data
        clearable
        outlined
        dense
      >
        <template v-slot:selection="data">
          {{ data.item.name }}/{{ data.item.state.acronym }}
        </template>
        <template v-slot:item="data">
          {{ data.item.name }}/{{ data.item.state.acronym }}
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="4" lg="3">
      <v-autocomplete
        @change="applyTypeFilter"
        @click:clear="clearTypeFilter"
        :label="$t('filters.serviceTypes')"
        :no-data-text="$t('appointment.filters.noData')"
        :items="serviceTypes"
        single-line
        return-object
        hide-no-data
        clearable
        outlined
        dense
      >
        <template v-slot:selection="data">
          {{ $t(`type.${data.item.value}`) }}
        </template>
        <template v-slot:item="data">
          {{ $t(`type.${data.item.value}`) }}
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import FilterSelect from '@/components/filters/FilterSelect'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import { paymentTypes, conditionals } from '@/config/constants'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'DefaultServiceValuesListFilters',

  components: {
    FilterSelect,
    FilterAutocomplete,
  },

  data() {
    return {
      paymentTypes,
      conditionals,
      _timer: null,
      cityLoading: false,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'serviceTypes', 'cities', 'filters']),
  },

  methods: {
    ...mapActions(['fetchDefaultServiceValues', 'fetchCitiesPaginated']),

    ...mapMutations(['setFilters', 'setCities']),

    setCitySearch({ target }) {

      clearTimeout(this._timer)

      this._timer = setTimeout(() => {
        if (target.value && target.value.length >= 3) {
          this.cityLoading = true

          this.setFilters({ search: target.value })

          this.fetchCitiesPaginated().finally(() => {
            this.cityLoading = false
          })

          this.setFilters({
            ...this.$store.getters.filters,
            ...{ search: null },
          })
        }
      }, 500)
    },

    applyCityFilter(city) {
      if (city) {
        this.setFilters({
          ...this.$store.getters.filters,
          ...{ cityId: city.id },
        })

        this.fetchDefaultServiceValues()
      }
    },

    clearCityFilter() {
      this.setFilters({
        ...this.$store.getters.filters,
        ...{ cityId: null },
      })

      this.fetchDefaultServiceValues()
    },

    applyTypeFilter({ value }) {
      if (value) {
        this.setFilters({
          ...this.$store.getters.filters,
          ...{ serviceTypes: value },
        })

        this.fetchDefaultServiceValues()
      }
    },

    clearTypeFilter() {
      this.setFilters({
        ...this.$store.getters.filters,
        ...{ serviceTypes: null },
      })

      this.fetchDefaultServiceValues()
    },
  },
}
</script>
